import { render, staticRenderFns } from "./BudgetSummary.vue?vue&type=template&id=2ed71131&"
import script from "./BudgetSummary.vue?vue&type=script&lang=ts&"
export * from "./BudgetSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports